var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarAddAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0237 9.47344C20.4342 9.07316 20.5896 8.59663 20.4498 8.16634C20.3099 7.73595 19.9042 7.44178 19.3369 7.35928L14.9088 6.71591C14.4324 6.64653 13.8047 6.1907 13.5916 5.75909L11.6115 1.74705C11.3577 1.23256 10.9525 0.9375 10.5001 0.9375C10.0474 0.9375 9.6422 1.23256 9.38848 1.74695L7.40819 5.75933C7.1954 6.19075 6.56779 6.64658 6.09145 6.71596L1.66356 7.35933C1.09601 7.44183 0.690322 7.736 0.550435 8.16638C0.410454 8.59667 0.565769 9.0732 0.976399 9.47348L4.18035 12.5966C4.52536 12.9328 4.76492 13.6708 4.68355 14.1449L3.92696 18.5551C3.82673 19.1402 4.00373 19.4978 4.16981 19.695C4.37005 19.9322 4.66022 20.0627 4.98675 20.0627C5.22325 20.0627 5.47184 19.9949 5.72536 19.8618L9.68609 17.7793C9.88896 17.6729 10.1856 17.6119 10.5001 17.6119C10.8142 17.6119 11.1112 17.6729 11.314 17.7797L15.2741 19.8614C15.5282 19.9952 15.7766 20.0626 16.013 20.0626C16.3396 20.0626 16.6298 19.9322 16.8299 19.695C16.9961 19.4978 17.173 19.1401 17.0726 18.5551L16.3162 14.1451C16.2351 13.6707 16.4752 12.9328 16.8194 12.5966L20.0237 9.47344Z",
    fill: "#E7B05E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarAddAccount);
export default __webpack_public_path__ + "static/media/star-add-account.434159ad17d06836e3c4aef417adabe7.svg";
export { ForwardRef as ReactComponent };